import { render, staticRenderFns } from "./newsbox2.vue?vue&type=template&id=40283849&scoped=true&"
import script from "./newsbox2.vue?vue&type=script&lang=js&"
export * from "./newsbox2.vue?vue&type=script&lang=js&"
import style0 from "./newsbox2.vue?vue&type=style&index=0&id=40283849&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40283849",
  null
  
)

export default component.exports